import cn from 'classnames';
import type { ReactNode } from 'react';
import { Avatar, Flex, Radio, Text } from 'ui';

type P = {
  active: boolean;
  description: string;
  icon: ReactNode;
  title: string;
  value: boolean;
};

const InvitationsDuplicateFormContentOption = ({ active, description, icon, title, value }: P) => (
  <Radio
    classNames={{
      label: 'invitations-duplicate-form-content-option-radio-label',
      root: 'invitations-duplicate-form-content-option-radio-root',
    }}
    value={value}
  >
    <Flex align="center" gap="medium" justify="center">
      <Avatar
        className={cn({
          'invitations-duplicate-form-content-option-active-avatar': active,
          'invitations-duplicate-form-content-option-inactive-avatar': !active,
        })}
        icon={icon}
      />
      <div>
        <Text type="title" weight="medium">
          {title}
        </Text>
        <br />
        <Text size="small">{description}</Text>
      </div>
    </Flex>
  </Radio>
);

export default InvitationsDuplicateFormContentOption;
